const contentEn = {
  "common.edit": "Edit",
  "common.select_all": "Select all",
  "nav.pages": "Pages",
  "nav.preferences": "Preferences",
  "nav.menus": "Navigation menus",
  "nav.blog_posts": "Blog",
  "nav.form_submissions": "Messages",

  // visibility (pages and blog posts)
  "vis.title": "Visibility",
  "vis.visible": "Visible",
  "vis.hidden": "Hidden",
  "vis.scheduled": "Scheduled",
  "vis.set_date": "Set visibility date",
  "vis.publish_on": "Visible on {date}",
  "vis.clear_date": "Clear date",
  "vis.visible_since": "Visible since {date}",

  "template.title": "Theme template",
  "template.default": "Default {type}",
  "template.custom_page": "Custom page: {name}",
  "template.custom_page_hint": "Custom pages are Liquid files in your theme's custom_pages folder.",

  // pages
  "pages.title": "Pages",
  "pages.add": "Add page",
  "pages.empty_title": "Add pages to your storefront",
  "pages.empty_body": "Write clear page titles and descriptions to improve your search engine optimization (SEO) and help customers find your website.",
  "pages.col.title": "Title",
  "pages.col.updated": "Updated",
  "pages.filter.all": "All",
  "pages.filter.visible": "Visible",
  "pages.filter.hidden": "Hidden",
  "pages.selected": "{count} selected",
  "pages.show": "Make visible",
  "pages.hide": "Hide",
  "pages.delete": "Delete pages",
  "pages.delete_confirm": "Delete {count} page(s)?",
  "pages.delete_body": "Deleted pages can't be recovered. Their URLs will show “Page not found”.",
  "pages.content": "Content",
  "pages.view": "View page",
  "pages.handle_hint": "Changing the URL creates a redirect from the old one.",
  "pages.seo_preview": "Search engine listing",
  "pages.seo_hint": "Add a title and description to see how this page might appear in a search engine listing.",
  "pages.seo_title_count": "{count} of 70 characters used",
  "pages.seo_description_count": "{count} of 160 characters used",
  "pages.not_found": "This page doesn't exist or was deleted.",

  // blog posts
  "blog.title": "Blog posts",
  "blog.add": "Add blog post",
  "blog.manage": "Manage blogs",
  "blog.comments_link": "Comments",
  "blog.empty_title": "Write a blog post",
  "blog.empty_body": "Blog posts are a great way to build a community around your products and your brand.",
  "blog.col.title": "Title",
  "blog.col.blog": "Blog",
  "blog.col.author": "Author",
  "blog.col.updated": "Updated",
  "blog.all_blogs": "All blogs",
  "blog.excerpt": "Excerpt",
  "blog.excerpt_hint": "Add a summary of the post to appear on your home page or blog.",
  "blog.organization": "Organization",
  "blog.author": "Author",
  "blog.blog": "Blog",
  "blog.tags": "Tags",
  "blog.image": "Image",
  "blog.image_alt": "Image alt text",
  "blog.delete": "Delete blog post",
  "blog.delete_confirm": "Delete {title}?",
  "blog.delete_many": "Delete {count} blog post(s)?",
  "blog.need_blog": "Create a blog first.",
  "blog.new_blog": "New blog",
  "blog.blog_title": "Blog title",
  "blog.comments": "Comments",
  "blog.comments.disabled": "Comments are disabled",
  "blog.comments.moderated": "Comments are allowed, pending moderation",
  "blog.comments.auto_published": "Comments are allowed, and are automatically published",
  "blog.delete_blog": "Delete blog",
  "blog.delete_blog_confirm": "Delete {title} and its {count} post(s)?",
  "blog.posts_count": "{count} posts",

  // comments
  "comments.title": "Comments",
  "comments.pending": "Pending",
  "comments.published": "Published",
  "comments.spam": "Spam",
  "comments.removed": "Removed",
  "comments.empty": "No comments here.",
  "comments.on": "on {title}",
  "comments.approve": "Publish",
  "comments.mark_spam": "Spam",
  "comments.not_spam": "Not spam",
  "comments.remove": "Remove",

  // menus
  "menus.title": "Menus",
  "menus.add": "Create menu",
  "menus.redirects": "View URL redirects",
  "menus.col.title": "Title",
  "menus.col.items": "Menu items",
  "menus.name": "Name",
  "menus.handle": "Handle",
  "menus.handle_hint": "Themes use the handle to find the menu.",
  "menus.items": "Menu items",
  "menus.add_item": "Add menu item",
  "menus.empty_items": "This menu doesn't have any items.",
  "menus.item_title": "Label",
  "menus.item_link": "Link",
  "menus.edit_item": "Edit menu item",
  "menus.add_child": "Add item under {title}",
  "menus.missing": "The linked item was deleted",
  "menus.delete": "Delete menu",
  "menus.delete_confirm": "Delete {title}?",
  "menus.protected": "The main menu and footer menu can't be deleted.",
  "menus.move_up": "Move up",
  "menus.move_down": "Move down",
  "menus.indent": "Nest under the item above",
  "menus.outdent": "Move out a level",
  "menus.depth_hint": "Menus can be up to 3 levels deep.",
  "link.search": "Search or paste a link",
  "link.type.home": "Home page",
  "link.type.catalog": "All products",
  "link.type.collections": "All collections",
  "link.type.search": "Search page",
  "link.type.product": "Products",
  "link.type.collection": "Collections",
  "link.type.page": "Pages",
  "link.type.blog": "Blogs",
  "link.type.article": "Blog posts",
  "link.type.policy": "Policies",
  "link.type.custom_page": "Custom pages",
  "link.type.url": "Web address",
  "link.none": "Nothing found",
  "link.back": "Back",
  "link.choose": "Choose a link",

  // redirects
  "redirects.title": "URL redirects",
  "redirects.add": "Create URL redirect",
  "redirects.import": "Import",
  "redirects.export": "Export",
  "redirects.empty_title": "Manage your store's URL redirects",
  "redirects.empty_body": "When you change a URL, send visitors who use the old link to the new page.",
  "redirects.from": "Redirect from",
  "redirects.to": "Redirect to",
  "redirects.from_hint": "Example: /old-page",
  "redirects.to_hint": "Example: /new-page or a full https:// link",
  "redirects.force": "Redirect even if a page exists at this URL",
  "redirects.temporary": "Temporary redirect (302)",
  "redirects.auto": "Automatic",
  "redirects.delete": "Delete redirects",
  "redirects.delete_confirm": "Delete {count} redirect(s)?",
  "redirects.import_title": "Import URL redirects by CSV",
  "redirects.import_hint": "The file has two columns, “Redirect from” and “Redirect to”. Up to 20,000 rows.",
  "redirects.import_done": "{count} redirects imported",
  "redirects.import_errors": "These rows weren't imported:",
  "redirects.row": "Row {row}",
  "redirects.sample": "Download a sample CSV",
  "redirects.choose_file": "Choose file",

  // policies
  "policies.title": "Policies",
  "policies.hint": "Policies are linked in your checkout footer and can be added to your store's menus.",
  "policies.notice": "These were drafted from your store details. Review them before you launch: they aren't legal advice.",
  "policies.settings_hint": "Refund, privacy, terms and other store policies",
  "policies.view": "View",
  "policies.empty": "No content: the policy is hidden on your store.",

  // preferences
  "prefs.title": "Preferences",
  "prefs.seo": "Title and meta description",
  "prefs.seo_hint": "The title and meta description help define how your store shows up on search engines.",
  "prefs.home_title": "Home page title",
  "prefs.home_description": "Meta description",
  "prefs.share_image": "Social sharing image",
  "prefs.share_image_hint": "When you share a link to your store on social media, an image is usually shown in your post. 1200 × 628 px recommended.",
  "prefs.add_image": "Add image",
  "prefs.password": "Password protection",
  "prefs.password_hint": "Restrict access to visitors with the password.",
  "prefs.password_enabled": "Restrict access with a password",
  "prefs.password_field": "Password",
  "prefs.password_set": "A password is set. Enter a new one to change it.",
  "prefs.password_message": "Message for your visitors",
  "prefs.launch_note": "Your store is behind a password until you launch it. Remove it from Settings > Store status.",
  "prefs.spam": "Spam protection",
  "prefs.spam_hint": "Filter likely spam from contact forms and blog comments.",
  "prefs.spam_enabled": "Filter spam in contact and comment forms",
  "prefs.blocked": "Blocked countries",
  "prefs.blocked_hint": "Visitors from these countries see a notice instead of your store.",
  "prefs.add_country": "Add a country",

  // form submissions
  "forms.title": "Form submissions",
  "forms.inbox": "Inbox",
  "forms.spam": "Spam",
  "forms.empty_title": "No messages yet",
  "forms.empty_body": "Messages from your contact form show here, and are emailed to your store's contact email.",
  "forms.mark_read": "Mark as read",
  "forms.mark_unread": "Mark as unread",
  "forms.delete": "Delete",
  "forms.delete_confirm": "Delete {count} message(s)?",
  "forms.export": "Export",
  "forms.from_page": "Sent from {page}",
  "forms.unread": "{count} unread",
  "forms.phone": "Phone",
  "forms.reply": "Reply",
} as const;

export default contentEn;
